export enum AdminRoute {
  CustomerList = '/admin/customers',
  Home = '/admin',
  LogisticsList = '/admin/logistics',
  OrderList = '/admin/orders',
  UserDetails = '/admin/users/:userId',
  UserList = '/admin/users',
  UserNew = '/admin/users/new',
}

export enum PrivateRoute {
  Home = '/',
  OrderList = '/orders',
  PaymentConfirm = '/payments/confirm',
  RequestNew = '/requests/new',
}

export enum PublicRoute {
  AboutUs = '/about',
  ContactUs = '/contact',
  CustomerSignup = '/register/customer',
  Faq = '/faq',
  RequestPasswordReset = '/forgot-password',
  Home = '/main',
  Login = '/login',
  LogisticsSignup = '/register/logistics',
  Logout = '/logout',
  PrivacyPolicy = '/privacy',
  ResetPassword = '/reset-password',
  TermsOfService = '/terms',
}
